import React, { useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard, EffectCoverflow } from 'swiper';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import Style from './index.css';

const Page3 = (props) => {
    const { peopleList, index } = props;

    const [peopleIndex, setPeopleIndex] = useState(0);

    return (
        <div className={Style.page2}>
            <div className={Style.swiperWp}>
                <div className={`${Style.navigation} ${Style.prev} ${Style.next}`} id="page3_prev" />

                <Swiper
                    effect={'coverflow'}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={1}
                    loop={true}
                    coverflowEffect={{
                        rotate: 0,
                        stretch: 20,
                        depth: 10,
                        modifier: 8,
                        slideShadows: false,
                    }}
                    loopAdditionalSlides={2}
                    key={index}
                    modules={[EffectCoverflow, Navigation, Pagination, Keyboard]}
                    className={Style.swiper}
                    speed={1500}
                    navigation={{
                        prevEl: '#page3_prev',
                        nextEl: '#page3_next',
                    }}
                    pagination={{
                        el: `.${Style.pagination}`,
                        type: 'fraction',
                    }}
                    keyboard={{
                        enabled: true,
                    }}>
                    {peopleList[index]?.imageList.map((image, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <div className={Style.swiperItem}>
                                    <img src={formatImageWebpAuto(image, 1118, 629)} alt="" />
                                    <div className={Style.itemMask} />
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>

                <div className={`${Style.navigation} ${Style.next}`} id="page3_next" />

                <div className={Style.pagination} />
            </div>
        </div>
    );
};

Page3.propTypes = {
    peopleList: PropTypes.array,
    index: PropTypes.number,
};

export default errorBoundary(Page3);
